<template>
  <div class="orders">
    <Orders/>
  </div>
</template>

<script>
// @ is an alias to /src
import Orders from '@/components/Orders/Orders.vue'

export default {
  name: 'orders',
  components: {
    Orders
  }
}
</script>